import { CustomRequestsOptions } from '@cutr/constants/windows/windows-configurations.ts';
import { useId } from 'react';
import { useTranslation } from 'react-i18next';

import { Textarea } from '@/primitives/Input';
import { Label } from '@/windows/primitives/Label';

import {
  ConfigurationsAction,
  useConfigurations,
} from '../ConfigurationsContext';

type ConfigurationTextAreaInputProps = {
  configurationKey: keyof CustomRequestsOptions;
  dispatchAction: Extract<ConfigurationsAction['type'], 'SET_CUSTOM_REQUESTS'>;
};

export const ConfigurationTextArea = ({
  configurationKey,
  dispatchAction,
}: ConfigurationTextAreaInputProps) => {
  const { t } = useTranslation();
  const { configurations, dispatch } = useConfigurations();
  const labelId = useId();
  const inputId = useId();

  return (
    <>
      <Label id={labelId} htmlFor={inputId}>
        {t(`windows.configurations.${configurationKey}.label`)}
      </Label>
      <Textarea
        aria-labelledby={labelId}
        id={inputId}
        value={configurations.customRequests?.[configurationKey] || ''}
        onChange={(event) => {
          dispatch({
            type: dispatchAction,
            value: {
              ...configurations.customRequests,
              [configurationKey]: event.target.value,
            },
          });
        }}
      />
    </>
  );
};
